import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { DropdownOption } from "@teamprevent/common/questionnaires/model";

import { OhCase } from "../../crud/ohCase";
import { TaskWithActions } from "../../task";

import { Link } from "redux-little-router";

interface CaseTaskCardProps {
    task: TaskModel;
    customerId: string;
    employeeRecordId: string;
    ohCase: OhCase;
    adminUserOptions: DropdownOption[];
}

export const CaseTaskCard: React.FunctionComponent<CaseTaskCardProps> = (props: CaseTaskCardProps) => {
    return (
        <TaskWithActions task={props.task} customerId={props.customerId} adminUserOptions={props.adminUserOptions}>
            <Link
                href={`/customers/${props.customerId}/employeeRecords/${props.employeeRecordId}/ohCases/${props.ohCase.id}`}
                target="_blank"
            >
                Case {props.ohCase.caseId} - {props.ohCase.caseType} Case
            </Link>
        </TaskWithActions>);
};
